


















































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { GapFilter } from "@/store/modules/types";
import { MessageType } from "@/store/modules/enums";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import GapPager from "@/components/gap/GapPager.vue";
import GapList from "@/components/gap/GapList.vue";
import GapPriority from "@/components/gap/GapPriority.vue";
import GapStatus from "@/components/gap/GapStatus.vue";
import GapEditor from "@/components/gap/GapEditor.vue";
import GapLog from "@/components/gap/GapLog.vue";
import GapNotifier from "@/components/gap/GapNotifier.vue";
import PatientEditor from "@/components/patient/PatientEditor.vue";
import ApptEditor from "@/components/schedule/Appt.vue";

@Component({
  components: {
    Header,
    EntityTabs,
    GapPager,
    GapList,
    GapPriority,
    GapStatus,
    GapEditor,
    GapLog,
    GapNotifier,
    PatientEditor,
    ApptEditor,
  },
  computed: {
    ...mapState("gaps", ["filter"]),
  },
})
export default class Gaps extends Vue {
  filter!: GapFilter;
  pageRows: Array<any> = [];
  totalRows: Number = 0;
  totalPatients: Number = 0;
  priorityCount: Array<any> = [];
  statusCount: Array<any> = [];
  subStatusCount: Array<any> = [];
  selected: any | null = null;
  selectedAppt: any | null = null;
  messageType = MessageType;
  notifMessageType: MessageType | null = null;
  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.getGaps();
  }
  orderBy(field: string) {
    this.$store.commit("gaps/SET_ORDER_BY_FILTER", field);
  }
  getAll() {
    this.getGaps();
    this.getPriorityCount();
    this.getStatusCount();
    this.getSubStatusCount();
  }
  async getGaps() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("gaps/getList");
      this.totalRows = data.totalRows;
      this.totalPatients = data.totalPatients;
      this.pageRows = data.pageRows.map((gap) => {
        gap.checked = false;
        gap.notifPhones = [];
        gap.notifPhone = {
          type: null,
          number: null,
        };
        gap.notifError = null;
        gap.notifSent = false;
        return gap;
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getGapsCSV() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("gaps/getListCSV");
      const blob = new Blob([data], { type: "text/csv" });
      const anchor = document.createElement("a");
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      anchor.download = `GAPS_${timestamp}.csv`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

   async getGapLogExcel() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("gaps/getListLogExcel");
      const mime = "application/octet-stream";
      const blob = new Blob([data], { type: mime });
      const anchor = document.createElement("a");
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      anchor.download = `GAP_LOG_${timestamp}.xlsx`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [
        mime,
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getGapCount() {
    try {
      const data = await this.$store.dispatch("gaps/getCount", this.filter);
      // PRIORITY COUNT
      let priorityCount: Array<any> = [
        ...new Set(data.map((row) => row.priorityId)),
      ];
      priorityCount = priorityCount.map((id) => {
        const item = data.find((item) => item.priorityId === id);
        return {
          id,
          name: item.priorityName,
          backColor: item.priorityBackColor,
          fontColor: item.priorityFontColor,
          gaps: data
            .filter((row) => row.priorityId === id)
            .map((row) => row.gaps)
            .reduce((accumulator, value) => accumulator + value),
          patients: data
            .filter((row) => row.priorityId === id)
            .map((row) => row.patients)
            .reduce((accumulator, value) => accumulator + value),
        };
      });
      this.priorityCount = priorityCount;
      // STATUS COUNT
      let statusCount: Array<any> = [
        ...new Set(data.map((row) => row.statusId)),
      ];
      statusCount = statusCount.map((id) => {
        const item = data.find((item) => item.statusId === id);
        return {
          id,
          name: item.statusName,
          backColor: item.statusBackColor,
          fontColor: item.statusFontColor,
          gaps: data
            .filter((row) => row.statusId === id)
            .map((row) => row.gaps)
            .reduce((accumulator, value) => accumulator + value),
          patients: data
            .filter((row) => row.statusId === id)
            .map((row) => row.patients)
            .reduce((accumulator, value) => accumulator + value),
        };
      });
      this.statusCount = statusCount;
      // ACTIVITY COUNT
      let subStatusCount: Array<any> = [
        ...new Set(data.map((row) => row.subStatusId)),
      ];
      subStatusCount = subStatusCount.map((id) => {
        const item = data.find((item) => item.subStatusId === id);
        return {
          id,
          name: item.subStatusName,
          backColor: item.subStatusBackColor,
          fontColor: item.subStatusFontColor,
          gaps: data
            .filter((row) => row.subStatusId === id)
            .map((row) => row.gaps)
            .reduce((accumulator, value) => accumulator + value),
          patients: data
            .filter((row) => row.subStatusId === id)
            .map((row) => row.patients)
            .reduce((accumulator, value) => accumulator + value),
        };
      });
      this.subStatusCount = subStatusCount;
      //
    } catch (error) {
      console.log(error);
    }
  }
  async getPriorityCount() {
    try {
      this.priorityCount = await this.$store.dispatch(
        "gaps/getPriorityCount",
        this.filter
      );
    } catch (error) {
      console.log(error);
    }
  }
  async getStatusCount() {
    try {
      this.statusCount = await this.$store.dispatch(
        "gaps/getStatusCount",
        this.filter
      );
    } catch (error) {
      console.log(error);
    }
  }
  async getSubStatusCount() {
    try {
      this.subStatusCount = await this.$store.dispatch(
        "gaps/getSubStatusCount",
        this.filter
      );
    } catch (error) {
      console.log(error);
    }
  }
  resetFilter() {
    this.$store.commit("gaps/RESET_FILTER");
  }
  checkGaps() {
    this.pageRows.forEach((gap) => {
      gap.checked = true;
      gap.notifSent = false;
      gap.notifError = null;
    });
  }
  uncheckGaps() {
    this.pageRows.forEach((gap) => {
      gap.checked = false;
      gap.notifSent = false;
      gap.notifError = null;
    });
  }
  editGap(gap) {
    if (!this.entitySelected()) return;
    this.selected = gap;
    this.$modal.show("gap-editor");
  }
  editPatient(gap) {
    if (!this.entitySelected()) return;
    this.selected = gap;
    this.$modal.show("patient-editor");
  }
  newAppt(gap) {
    if (!this.entitySelected()) return;
    this.selected = gap;
    this.selectedAppt = null;
    this.$modal.show("appt-editor");
  }
   editAppt(id) {
    if (!this.entitySelected()) return;
    this.selected = null;
    this.selectedAppt = id;
    this.$modal.show("appt-editor");
  }
  showLog(gap) {
    this.selected = gap;
    this.$modal.show("gap-log");
  }
  showNotifier(messageType: MessageType) {
    if (!this.entitySelected()) return;
    if (!this.singleCampaignSelected()) return;
    if (!this.singleMeasureTypeSelected()) return;
    this.notifMessageType = messageType;
    this.$modal.show("gap-notifier");
  }
  entitySelected(): boolean {
    if (this.$store.state.auth.entityId == 0) {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text:
          "Please select an <span class='wm-fw-500'>area or division</span>.",
      });
      return false;
    }
    return true;
  }
  singleCampaignSelected(): boolean {
    if (this.distinctSelectedCampaigns.length > 1) {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text:
          "A batch cannot contain gaps from multiple <span class='wm-fw-500'>campaigns</span>.",
      });
      return false;
    }
    return true;
  }
  singleMeasureTypeSelected(): boolean {
    if (this.distinctSelectedMeasureTypes.length > 1) {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text:
          "A batch cannot contain gaps with multiple <span class='wm-fw-500'>measure types</span>.",
      });
      return false;
    }
    return true;
  }
  get rowsChecked(): Boolean {
    return this.checkedRows.length != 0;
  }
  get checkedRows() {
    return this.pageRows.filter((row) => {
      return row.checked;
    });
  }
  get distinctSelectedCampaigns(): Array<any> {
    return [...new Set(this.checkedRows.map((row) => row.campaignId))];
  }
  get distinctSelectedMeasureTypes(): Array<any> {
    return [...new Set(this.checkedRows.map((row) => row.measureTypeId))];
  }
  get notifCampaignId(): string | null {
    if (this.distinctSelectedCampaigns.length) {
      return this.distinctSelectedCampaigns[0];
    }
    return null;
  }
  get notifMeasureTypeId(): string | null {
    if (this.distinctSelectedMeasureTypes.length) {
      return this.distinctSelectedMeasureTypes[0];
    }
    return null;
  }
  mounted() {
    this.getGaps();
  }
}
